import {slideToggle, slideUp, index, preventSmootherUpdateOnAccordion} from '../utility/utils';

class TD_BIO_CARDS {
  constructor(element) {
    this.element = element;
    this.toggle = this.element.querySelector('.bio_card__toggle');
    this.toggleOriginalText = this.toggle ? this.toggle.textContent : '';
    this.clickEls = this.element.querySelectorAll('.bio_card__portrait, .bio_card__name, .bio_card__toggle'); 
    this.isOpen = false;
    this.content = this.element.querySelector('.bio_card__bio');
    this.isDesktop = this.toggle && this.toggle.offsetParent === null ? true : false;

    this.watchClickEvents();

    this.watchScreenSizeEvents();
  }

  watchClickEvents() {
    this.clickEls.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();

        if(this.isDesktop) return;

        this.isOpen = !this.isOpen;
        this.element.classList.toggle('bio_card--expanded');

        if(this.isOpen) {
          this.toggle.textContent = 'Close';
        } else {
          this.toggle.textContent = this.toggleOriginalText;
        }

        this.content.classList.toggle('active');

        // Toggle Aria-Hidden attribute
        const aria_hidden = this.content.classList.contains('active') ? 'false' : 'true';
        this.content.setAttribute('aria-hidden', aria_hidden);

        // Toggle Content Height
        slideToggle(this.content);
      });
    });
  }

  watchScreenSizeEvents() {
    // Since we don't know the card breakpoint (uses container queries), check if the toggle is visible
    

    const handleScreenChange = () => {
      this.isDesktop = this.toggle.offsetParent === null ? true : false;
      if(this.isDesktop) {
        // If screen is desktop size, remove aria-hidden and active classes
        this.isOpen = false;
        this.element.classList.remove('bio_card--expanded');
        this.content.classList.remove('active');
        this.content.setAttribute('aria-hidden', 'false');
        this.content.style.removeProperty('display');
        this.toggle.textContent = this.toggleOriginalText;
      }
    }

    // Initial check
    handleScreenChange();

    // Listen for screen size changes
    let debouncer = null;
    window.addEventListener('resize', () => {
      clearTimeout(debouncer);
      debouncer = setTimeout(() => {
        handleScreenChange();
      }, 150);
    });
  }
}

export function initializeBioCards() {
  const bioCardElements = document.querySelectorAll('.bio_card');

  bioCardElements.forEach((element) => {
    new TD_BIO_CARDS(element);
  });
}